import React from 'react';
import ReactDOM from 'react-dom/client';
import { StoreProvider, store } from '@link/metro-24h/stores';
import '@link/metro-24h/i18n';
import '@link/metro-24h/styles/index.css';
import App from '@link/metro-24h/App';

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <StoreProvider value={store}>
      <App />
    </StoreProvider>
  </React.StrictMode>
);
